import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { Tag } from "primereact/tag";

import { useReport } from "../../context/report";
import ProducaoGeral from "../ProducaoGeral";

export default function EficienciaReal() {
    const { data } = useReport();

    const formatNumber = (rowData, props) => {
        return (
            <Tag className={parseFloat(rowData[props.field]) > data.eficiencia_baixa ? "p-tag-success" : "p-tag-danger" }>
                {Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(rowData[props.field]) + "%"}
            </Tag>
        );
    }

    return (
        <div>
            <Panel
                collapsed
                header="TABELA DE PRODUÇÃO REAL POR DIA"
                toggleable
            >
                {data.dados.map((item, index) => (
                    <div key={index}>
                        <div className="p-d-flex p-flex-row p-jc-center p-p-3 p-mb-3" style={{ backgroundColor: item.color }}>
                            <h3 className="p-m-0" style={{ color: "#fff" }}>TURMA {item.turma}</h3>
                        </div>
                        <div className="p-grid">
                            {item.dados.map((grupo) => (
                                <div className="p-col">
                                    <div className="p-p-3" style={{ backgroundColor: item.color }}>
                                        <h3 className="p-m-0 p-text-center" style={{ color: "#fff" }}>G{grupo.grupo}</h3>
                                    </div>
                                    <DataTable
                                        responsiveLayout="scroll"
                                        size="small"
                                        value={grupo.dados}
                                    >
                                        <Column header="Data" field="data" />
                                        <Column header="Eficiência" field="eficiencia" body={formatNumber} />
                                    </DataTable>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </Panel>
            <ProducaoGeral dataProps={data.producao_geral} />
        </div>
    )
}